import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { MotionDiv, StaggerGrid, StaggerItem } from "../../utils/animations";
import { Link } from "react-router-dom";
import fondoServicios from "../../assets/images/site/fondo-servicios.webp";

const features = [
    {
        key: "web",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="feature-card-icon-svg">
                <path fillRule="evenodd" d="M2.25 5.25a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3V15a3 3 0 0 1-3 3h-3v.257c0 .597.237 1.17.659 1.591l.621.622a.75.75 0 0 1-.53 1.28h-9a.75.75 0 0 1-.53-1.28l.621-.622a2.25 2.25 0 0 0 .659-1.59V18h-3a3 3 0 0 1-3-3V5.25Zm1.5 0v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5Z" clipRule="evenodd" />
            </svg>
        ),
        color: "feature-card--blue",
        href: "/servicios/software-y-aplicaciones",
    },
    {
        key: "mobile",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="feature-card-icon-svg">
                <path d="M10.5 18.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z" />
                <path fillRule="evenodd" d="M8.625.75A3.375 3.375 0 0 0 5.25 4.125v15.75a3.375 3.375 0 0 0 3.375 3.375h6.75a3.375 3.375 0 0 0 3.375-3.375V4.125A3.375 3.375 0 0 0 15.375.75h-6.75ZM7.5 4.125C7.5 3.504 8.004 3 8.625 3H9.75v.375c0 .621.504 1.125 1.125 1.125h2.25c.621 0 1.125-.504 1.125-1.125V3h1.125c.621 0 1.125.504 1.125 1.125v15.75c0 .621-.504 1.125-1.125 1.125h-6.75A1.125 1.125 0 0 1 7.5 19.875V4.125Z" clipRule="evenodd" />
            </svg>
        ),
        color: "feature-card--pink",
        href: "/servicios/software-y-aplicaciones",
    },
    {
        key: "ai",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="feature-card-icon-svg">
                <path fillRule="evenodd" d="M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z" clipRule="evenodd" />
            </svg>
        ),
        color: "feature-card--purple",
        href: "/servicios/inteligencia-artificial",
    },
    {
        key: "security",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="feature-card-icon-svg">
                <path fillRule="evenodd" d="M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
            </svg>
        ),
        color: "feature-card--teal",
        href: "/servicios/ciberseguridad",
    },
    {
        key: "cloud",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="feature-card-icon-svg">
                <path fillRule="evenodd" d="M4.5 9.75a6 6 0 0 1 11.573-2.226 3.75 3.75 0 0 1 4.133 4.303A4.5 4.5 0 0 1 18 20.25H6.75a5.25 5.25 0 0 1-2.25-10.5Z" clipRule="evenodd" />
            </svg>
        ),
        color: "feature-card--cyan",
        href: "/servicios/software-y-aplicaciones",
    },
    {
        key: "aviation",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="feature-card-icon-svg">
                <path d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z" />
            </svg>
        ),
        color: "feature-card--blue",
        href: "/ia-aviacion-seguridad-operacional",
    },
];

function FeaturesSection() {
    const { t } = useTranslation();
    return (
        <section id="servicios" className="features-section">
            <div className="section-bg" aria-hidden="true">
                <img src={fondoServicios} alt="" className="section-bg-img" loading="lazy" decoding="async" />
            </div>
            <div className="section-container">
                <MotionDiv className="section-header">
                    <div className="section-tag">{t("features.tag")}</div>
                    <h2 className="section-title">{t("features.title")}</h2>
                    <p className="section-subtitle">
                        {t("features.subtitle")}
                    </p>
                </MotionDiv>

                <StaggerGrid className="features-grid">
                    {features.map((f) => (
                        <StaggerItem key={f.key}>
                            <motion.article
                                className={`feature-card ${f.color}`}
                                whileHover={{ y: -8, scale: 1.02, rotateX: 2 }}
                                transition={{ type: "spring", stiffness: 300, damping: 18 }}
                            >
                                <div className="feature-card-icon-wrap">{f.icon}</div>
                                <h3 className="feature-card-title">{t(`features.items.${f.key}.title`)}</h3>
                                <p className="feature-card-desc">{t(`features.items.${f.key}.description`)}</p>
                                <Link to={f.href} className="feature-card-link">
                                    {t("features.linkMore")}
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="feature-card-link-arrow">
                                        <path fillRule="evenodd" d="M6.22 4.22a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.75.75 0 0 1-1.06-1.06L9.19 8 6.22 5.03a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
                                    </svg>
                                </Link>
                            </motion.article>
                        </StaggerItem>
                    ))}
                </StaggerGrid>

                <MotionDiv className="mt-8 flex justify-center px-4" delay={0.2}>
                    <motion.div
                        className="w-full max-w-4xl"
                        whileHover={{ y: -8, scale: 1.01 }}
                        transition={{ type: "spring", stiffness: 260, damping: 20 }}
                    >
                        {/* <img
                            src={imagen2}
                            alt="Arquitectura tecnológica multicanal"
                            className="w-full h-auto object-contain mx-auto rounded-xl drop-shadow-2xl"
                        /> */}
                    </motion.div>
                </MotionDiv>
            </div>
        </section>
    );
}

export default FeaturesSection;
